import type { AdminEpisodeSummary } from "@storyline/shared";
import { Link } from "react-router";
import Pill from "@/src/common/components/pill";
import {
	PRODUCTION_STATE_LABELS,
	PRODUCTION_STATE_TONES,
	STORY_STATUS_LABELS,
	STORY_STATUS_TONES,
} from "@/src/common/constants/studio-labels";

type EpisodesListProps = {
	seriesId: string;
	episodes: AdminEpisodeSummary[];
};

const EpisodesList: React.FC<EpisodesListProps> = ({ seriesId, episodes }) => {
	if (episodes.length === 0) {
		return <p className="text-muted text-sm">Aucun épisode. Lancez le copilote pour en proposer un.</p>;
	}

	return (
		<div className="flex flex-col gap-2">
			{episodes.map((episode) => (
				<Link
					key={episode.id}
					to={`/series/${seriesId}/episodes/${episode.id}`}
					className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border-soft bg-surface-2 p-4 transition hover:border-accent-lav"
				>
					<div className="flex items-center gap-3">
						<span className="flex size-9 items-center justify-center rounded-lg bg-accent-soft font-semibold text-accent-lav text-sm">
							E{episode.episodeNumber}
						</span>
						<span className="font-semibold text-foreground">{episode.title}</span>
					</div>
					<div className="flex items-center gap-2">
						<Pill tone={PRODUCTION_STATE_TONES[episode.productionState]}>{PRODUCTION_STATE_LABELS[episode.productionState]}</Pill>
						<Pill tone={STORY_STATUS_TONES[episode.status]}>{STORY_STATUS_LABELS[episode.status]}</Pill>
					</div>
				</Link>
			))}
		</div>
	);
};

export default EpisodesList;
